export class UserBriefingModel {
    userBriefingId?: number;
    briefingId?: number;
    userId?: number;
    createdBy?: number;
    createdTime?: any;
    modifiedBy?: number;
    modifiedTime?: any;
}
